<template>
    <div>
        <div class="my-16 py-5"></div>
        <v-footer fixed dark padless>
            <v-row class="ma-0 text-center">
                <v-col cols="4" class="px-0">
                    <v-btn class="pa-0" block to="/"><v-icon size="36px">mdi-clipboard-list-outline</v-icon></v-btn>
                </v-col>
                <v-col cols="4" class="px-0">
                    <v-btn class="pa-0" block :to="{ name: 'LastImages' }"><v-icon size="36px">mdi-youtube-subscription</v-icon></v-btn>
                </v-col>
                <v-col cols="4" class="px-0">
                    <v-btn class="pa-0" block :to="{ name: 'Settings' }"><v-icon size="36px">mdi-cog</v-icon></v-btn>
                </v-col>
                <v-col cols="12" class="pa-0">
                    <v-progress-linear :value="logoutProgress"></v-progress-linear>
                </v-col>
            </v-row>
        </v-footer>
    </div>
</template>

<script>
import Config from "@/config.json";
import mqtt from "mqtt";
export default {
    name: "CommonFooter",
    //########################################################
    data() {
        return {
            //-----------------------------
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mac: "ff:ff:ff:ff:ff:ff", //"b8:27:eb:e5:25:c0",
            mqttClient: { connected: false },
            //-----------------------------
            jwt: "",
            myInfo: [],
            intID: undefined,
            logoutProgress: 100,
        };
    },
    //########################################################
    created: async function () {
        //-----------------------
        //this.connectMqtt();
        this.autoLogout();
    },
    //########################################################
    beforeDestroy: async function () {
        //this.disconnectMqtt();
        clearInterval(this.intID);
    },
    //########################################################
    methods: {
        //====================================================
        autoLogout() {
            const gThis = this;
            gThis.intID = setInterval(function () {
                gThis.jwt = gThis.$localStorage.get("jwt");
                if (gThis.jwt) {
                    gThis.myInfo = gThis.$jwt.decode(gThis.jwt);
                    if (gThis.myInfo && gThis.myInfo.exp) {
                        const exp = gThis.$moment.unix(gThis.myInfo.exp).add(-30, "seconds").unix();
                        const now = gThis.$moment().unix();
                        //self.console.log({ exp, now });
                        if (exp < now) {
                            gThis.$router.push({ name: "Logout" });
                            return;
                        }
                        const totalSec = 60 * 60;
                        const lastSec = exp - now;
                        gThis.logoutProgress = Math.floor((lastSec / totalSec) * 100);
                    }
                }
            }, 1000 * 10);
        },
        //====================================================
        async connectMqtt() {
            this.jwt = this.$localStorage.get("jwt");
            if (!this.jwt) return;
            //-----------------
            if (this.mqttClient.connected) return true;
            //-----------------
            //const gThis = this;
            //-----------------
            this.mqttClient = mqtt.connect(
                this.mqttHost
                //{ username: this.mqttID, password: this.mqttPW }
            );
            //-----------------
            this.mqttClient.on("connect", function () {
                self.console.log("Footer MQTT Connected !!");
            });
            //-----------------
            this.mqttClient.subscribe(this.mqttTopicSub + "/#");
        },
        //====================================================
        disconnectMqtt() {
            if (!this.mqttClient.connected) return true;
            this.mqttClient.end();
            self.console.log("Footer MQTT disconnect !!");
        },
        //====================================================
    },
};
</script>
